import React, { useEffect, useRef } from "react";
import { ScrollerItem } from "../../utils/types";
import LazyImage from "../LazyImage";

type HorizontalScrollerProps = {
  items: ScrollerItem[];
};

const HorizontalScroller: React.FC<HorizontalScrollerProps> = ({ items }) => {
  const scrollerRef = useRef<HTMLDivElement>(null);
  const animationFrameId = useRef<number | null>(null);

  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;

    let start = 0;
    const scroll = () => {
      start += 1;
      if (start >= scroller.scrollWidth / 2) {
        start = 0;
      }
      scroller.scrollTo({ left: start, behavior: "auto" });
      animationFrameId.current = requestAnimationFrame(scroll);
    };

    scroll();

    return () => {
      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }
    };
  }, []);

  return (
    <div className="bg-[#10031dff] py-4 overflow-hidden">
      <div className="relative">
        <div
          ref={scrollerRef}
          className="flex space-x-4 overflow-x-auto scrollbar-hide"
        >
          {[...items, ...items].map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-center text-center space-x-2 p-4 rounded-lg border border-solid shadow-lg"
              style={{
                backgroundColor: "#1f142bff",
                borderColor: "transparent",
                borderImage:
                  "linear-gradient(to right, #5e5568ff, #5e5568ff) 1",
                boxShadow: "0px 4px 6px rgba(255, 255, 255, .2)",
                color: "var(--text-color)",
                minWidth: "200px", // Ensures uniform box width
              }}
            >
              {item.icon && (
                <LazyImage
                  src={item.icon}
                  alt={item.title}
                  className="w-8 h-8"
                />
              )}
              <span className="font-orbitron text-white">{item.title}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HorizontalScroller;
